// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `student-tiles div.tile {
  width: 22.375%;
  /* max-width: 22em;*/
  height: 300px;
  background-color: #ffffff;
  margin-right: 3%;
  margin-bottom: 1.5%;
  padding-right: 0;
  padding-left: 0;
  position: relative;
  border: 1px solid #00375d;
}

student-tiles div.rowEnd {
  margin-right: 0;
}

student-tiles .see-more-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

student-tiles .see-more-section > a {
  text-decoration: none;
  font-weight: bold;
}

student-tiles .align-glyph {
  padding-left: 5px;
  vertical-align: text-bottom;
}

student-tiles .scrollDown {
  background-color: white;
  border: 1px solid #00375d;
  width: 98.5%;
  margin-bottom: 1.5%;
}

student-tiles .infoSection {
  padding-left: 0px;
  padding-top: 4rem;
  margin-left: 10px;
  margin-bottom: 4px;
  color: black;
  font-size: 14px;
  list-style: none;
}

student-tiles .descriptionSection {
  margin-left: 10px;
  margin-bottom: 10px;
}
student-tiles .detailsTopContainer {
  width: 100%;
}

student-tiles .duedate {
  color: #00375d;
}

student-tiles .duedate-overdue {
  color: #f63f3f;
}

student-tiles .duedate-duesoon {
  color: #ffcc00;
}
student-tiles .offerings {
  margin-left: 10px;
}
student-tiles .courseGroup {
  background-color: #ffffff;
}
student-tiles .courseGroupContainer {
  width: 98.5%;
  margin-bottom: 20px;
  border: 1px solid #00375d;
}
student-tiles .courseGroupContainer .dueDate {
  margin-left: 10px;
  box-sizing: border-box;
  color: rgb(0, 55, 93);
  display: inline;
  font-family: Verdana, Arial, sans-serif;
  font-size: 12px;
  height: auto;
  line-height: 17.1429px;
  text-size-adjust: 100%;
  width: auto;
}

student-tiles .courseGroupContainer .mainImg {
  width: 100%;
}

student-tiles .courseGroupContainer .info {
  padding-left: 1rem;
  padding-bottom: 15px;
}

student-tiles .courseGroupContainer .assignmentName {
  margin-top: 0px;
  margin-bottom: 0px;
  font-weight: bold;
  font-size: 16px;
}
student-tiles .courseGroupContainer h3 {
  margin: 0px 0px 15px;
}

student-tiles .courseGroupContainer.courseMeta {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  padding-top: 0.1rem;
  flex-wrap: wrap;
}

student-tiles .courseGroupContainer .courseMetaContainer {
  margin-bottom: 3rem;
}

student-tiles .courseGroupContainer .imageDate {
  padding-left: 0px;
  padding-right: 0px;
}

student-tiles
  .courseGroupContainer
  .courseMeta
  span:nth-last-child(n + 2):after {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 0.9rem;
}

student-tiles .courseGroupContainer .title {
  margin-left: 15px;
  padding-left: 0px;
  width: 70%;
}

student-tiles .courseGroupScroll {
  margin-left: 1%;
  width: 98%;
}

student-tiles .resourceHeaders {
  padding-top: 4rem;
}
student-tiles .resourceName {
  width: 90%;
}

student-tiles .resourceNameDetails {
  width: 90%;
  overflow-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentTiles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":["student-tiles div.tile {\n  width: 22.375%;\n  /* max-width: 22em;*/\n  height: 300px;\n  background-color: #ffffff;\n  margin-right: 3%;\n  margin-bottom: 1.5%;\n  padding-right: 0;\n  padding-left: 0;\n  position: relative;\n  border: 1px solid #00375d;\n}\n\nstudent-tiles div.rowEnd {\n  margin-right: 0;\n}\n\nstudent-tiles .see-more-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\nstudent-tiles .see-more-section > a {\n  text-decoration: none;\n  font-weight: bold;\n}\n\nstudent-tiles .align-glyph {\n  padding-left: 5px;\n  vertical-align: text-bottom;\n}\n\nstudent-tiles .scrollDown {\n  background-color: white;\n  border: 1px solid #00375d;\n  width: 98.5%;\n  margin-bottom: 1.5%;\n}\n\nstudent-tiles .infoSection {\n  padding-left: 0px;\n  padding-top: 4rem;\n  margin-left: 10px;\n  margin-bottom: 4px;\n  color: black;\n  font-size: 14px;\n  list-style: none;\n}\n\nstudent-tiles .descriptionSection {\n  margin-left: 10px;\n  margin-bottom: 10px;\n}\nstudent-tiles .detailsTopContainer {\n  width: 100%;\n}\n\nstudent-tiles .duedate {\n  color: #00375d;\n}\n\nstudent-tiles .duedate-overdue {\n  color: #f63f3f;\n}\n\nstudent-tiles .duedate-duesoon {\n  color: #ffcc00;\n}\nstudent-tiles .offerings {\n  margin-left: 10px;\n}\nstudent-tiles .courseGroup {\n  background-color: #ffffff;\n}\nstudent-tiles .courseGroupContainer {\n  width: 98.5%;\n  margin-bottom: 20px;\n  border: 1px solid #00375d;\n}\nstudent-tiles .courseGroupContainer .dueDate {\n  margin-left: 10px;\n  box-sizing: border-box;\n  color: rgb(0, 55, 93);\n  display: inline;\n  font-family: Verdana, Arial, sans-serif;\n  font-size: 12px;\n  height: auto;\n  line-height: 17.1429px;\n  text-size-adjust: 100%;\n  width: auto;\n}\n\nstudent-tiles .courseGroupContainer .mainImg {\n  width: 100%;\n}\n\nstudent-tiles .courseGroupContainer .info {\n  padding-left: 1rem;\n  padding-bottom: 15px;\n}\n\nstudent-tiles .courseGroupContainer .assignmentName {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  font-weight: bold;\n  font-size: 16px;\n}\nstudent-tiles .courseGroupContainer h3 {\n  margin: 0px 0px 15px;\n}\n\nstudent-tiles .courseGroupContainer.courseMeta {\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  padding-top: 0.1rem;\n  flex-wrap: wrap;\n}\n\nstudent-tiles .courseGroupContainer .courseMetaContainer {\n  margin-bottom: 3rem;\n}\n\nstudent-tiles .courseGroupContainer .imageDate {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\nstudent-tiles\n  .courseGroupContainer\n  .courseMeta\n  span:nth-last-child(n + 2):after {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 0.9rem;\n}\n\nstudent-tiles .courseGroupContainer .title {\n  margin-left: 15px;\n  padding-left: 0px;\n  width: 70%;\n}\n\nstudent-tiles .courseGroupScroll {\n  margin-left: 1%;\n  width: 98%;\n}\n\nstudent-tiles .resourceHeaders {\n  padding-top: 4rem;\n}\nstudent-tiles .resourceName {\n  width: 90%;\n}\n\nstudent-tiles .resourceNameDetails {\n  width: 90%;\n  overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
